import { Box, Button, useTheme } from '@ltvco/refresh-lib/theme';

import { CONFIRM_CHIP_VARIANTS } from '../utils/constants';

interface ConfirmationChipProps {
  onConfirm: () => void;
  disabled?: boolean;
  variant: (typeof CONFIRM_CHIP_VARIANTS)[keyof typeof CONFIRM_CHIP_VARIANTS];
}

export const ConfirmationChip = ({
  onConfirm,
  disabled,
  variant,
}: ConfirmationChipProps) => {
  const theme = useTheme();
  return (
    <Box mb={2}>
      <Button
        onClick={onConfirm}
        disabled={disabled}
        sx={{
          backgroundColor: theme.palette.background.paper,
          width: '100%',
          maxWidth: '400px',
          height: '40px',
          border: disabled
            ? `1px solid ${theme.palette.background.paper}`
            : `1px solid ${theme.palette.primary.main}`,
          borderRadius: '16px',
          fontSize: '14px',
          padding: '4px 12px',
          textTransform: 'none',
          boxShadow: 'none',
          opacity: disabled ? 0.7 : 1,
          '&:hover': {
            boxShadow: 'none',
          },
        }}
      >
        {variant === CONFIRM_CHIP_VARIANTS.confirm
          ? 'Apply filters'
          : 'View results'}
      </Button>
    </Box>
  );
};
